import { render, staticRenderFns } from "./Capital.vue?vue&type=template&id=d00a6912&scoped=true"
import script from "./Capital.vue?vue&type=script&lang=js"
export * from "./Capital.vue?vue&type=script&lang=js"
import style0 from "./Capital.vue?vue&type=style&index=0&id=d00a6912&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00a6912",
  null
  
)

export default component.exports